<template>
	<gc-dialog
		title="批量任务创建"
		width="760px"
		:show.sync="visible"
		@close="$emit('close-modal')"
		@cancel="$emit('close-modal')"
		@ok="handleSubmitForm"
		:okLoading="requestLoading"
	>
		<el-form :model="modelForm" :rules="rules" ref="modelForm" label-position="top" label-width="100px">
			<div class="form-block">
				<div class="title">任务内容</div>
				<el-row :gutter="12">
					<el-col :span="24">
						<el-form-item label="任务名称" prop="taskName">
							<el-input size="small" v-model="modelForm.taskName" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="设备组" prop="deviceGroupId">
							<el-select v-model="modelForm.deviceGroupId" placeholder="请选择">
								<el-option
									v-for="item in deviceGroupOptions"
									:key="item.id"
									:label="item.deviceGroupName"
									:value="item.id"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作类型" prop="operationType ">
							<el-select v-model="modelForm.operationType" placeholder="请选择">
								<el-option
									v-for="item in MODULE_BATCH_TASK_TYPE_OPTIONS"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注" prop="remark">
							<el-input
								type="textarea"
								v-model="modelForm.remark"
								placeholder="请输入备注信息"
								:rows="3"
								resize="none"
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div class="form-block">
				<div class="title">
					文件导入
					<span class="download-template" @click="handleDownloadTemplate">下载数据模板</span>
				</div>
				<el-row :gutter="12">
					<el-col :span="24">
						<el-form-item prop="fileInfo" style="margin-top: 8px">
							<el-upload
								class="btn"
								ref="upload"
								action
								drag
								:auto-upload="false"
								:show-file-list="false"
								:on-change="handleUploadFileChange"
							>
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									将文件拖到此处，或
									<em>点击上传</em>
								</div>
							</el-upload>
						</el-form-item>
						<div v-if="modelForm.fileInfo" class="file-name">
							{{ modelForm.fileInfo.name }}（{{ modelForm.fileInfo.size }}）
							<i class="iconfont el-icon-circle-close" @click="handleRemoveExcelFile"></i>
						</div>
					</el-col>
					<el-col :span="24" :class="{ hidden: !validFailDataList.length }">
						<el-form-item>
							<div class="content-error-tip">
								<p>
									当前上传的文件有
									<span>{{ validFailDataList.length }}</span>
									条数据格式校验不通过，您可以
									<em @click="handleDownloadFailData">点击下载</em>
									查看校验不通过的数据
								</p>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
		</el-form>
	</gc-dialog>
</template>

<script>
import { apiDeviceImeiRegistTask } from '@/apis/communicationModelManage.api'
import { exportJsonToExcel } from '@/utils/excel/newExport2Excel'
import { moduleBatchTaskThead, MODULE_BATCH_TASK_TYPE_OPTIONS } from '@/config/const'
import { isBlank } from '@/utils/validate'
import { ruleRequired, ruleMaxLength } from '@/utils/rules'
const XLSX = require('xlsx')

export default {
	name: 'BatchTaskModal',
	props: {
		operateType: String,
		deviceGroupOptions: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			visible: true,
			MODULE_BATCH_TASK_TYPE_OPTIONS,
			requestLoading: false,
			downloadLoading: false,
			modelForm: {
				taskName: null,
				deviceGroupId: null,
				operationType: '1',
				remark: null,
				fileInfo: null,
			},
			rules: {
				taskName: [ruleRequired(), ruleMaxLength(50)],
				deviceGroupId: [ruleRequired('请选择')],
				operationType: [ruleRequired('请选择')],
				fileInfo: [ruleRequired('请先上传Excel文件')],
				remark: [ruleMaxLength(200)],
			},
			templateColumns: [],
			validFailDataList: [],
		}
	},

	methods: {
		handleSubmitForm() {
			this.$refs.modelForm.validate(async valid => {
				if (valid) {
					this.validFailDataList = []
					const available = this.validateExcelFileContent()
					if (available) {
						this.requestLoading = true
						const formdata = new FormData()
						for (const key in this.modelForm) {
							if (key !== 'fileInfo') {
								!isBlank(this.modelForm[key]) && formdata.append(key, this.modelForm[key])
							}
						}
						formdata.append('file', this.modelForm.fileInfo.raw)
						formdata.append('manufacturerId', this.manufacturerId)
						try {
							await apiDeviceImeiRegistTask(formdata)
							this.requestLoading = false
							this.$message.success('任务创建成功')
							this.$emit('close-modal', true)
						} catch (error) {
							this.requestLoading = false
						}
					}
				}
			})
		},

		/**
		 * 文件上传解析获取文件内数据信息
		 * @param {*} file
		 */
		handleUploadFileChange(file) {
			const { name, size, raw } = file
			if (!/\.(xls|xlsx)$/.test(name.toLowerCase())) {
				this.$message.error('上传文件格式不正确，请上传xls或xlsx格式文档')
				return false
			}
			if (size / 1024 / 1024 > 30) {
				this.$message.error('上传文件大小不得大于30M')
				return false
			}
			const loading = this.$loading({ text: '正在读取，请等待…' })
			const fileReader = new FileReader()
			fileReader.onload = ev => {
				try {
					const data = ev.target.result
					const workbook = XLSX.read(data, {
						type: 'binary',
					})
					const sheetNames = workbook.SheetNames
					const ws = XLSX.utils.sheet_to_json(workbook.Sheets[sheetNames[0]], {
						defval: null,
					})
					if (ws.length > 100000) {
						loading.close()
						return this.$message.error('上传数据不能超过100000条')
					}
					const fileSize =
						size > 1024 * 1024
							? (size / 1024 / 1024).toFixed(1) + 'M'
							: size > 1024
							? (size / 1024).toFixed(1) + 'KB'
							: size + 'B'
					loading.close()
					this.modelForm.fileInfo = { name, size: fileSize, data: ws, raw }
					this.$refs.modelForm.clearValidate('fileInfo')
					this.validFailDataList = []
				} catch {
					loading.close()
					this.$message.error('excel读取发生错误，请重新读取')
				}
			}
			fileReader.readAsBinaryString(raw)
		},

		/**
		 * 批量导入任务模板下载
		 */
		async handleDownloadTemplate() {
			if (this.downloadLoading) return
			this.downloadLoading = true
			await this.handleExcelImportTemalateExcel()
			this.downloadLoading = false
		},

		/**
		 * 上传的excel文件数据格式校验
		 */
		validateExcelFileContent() {
			const datalist = this.modelForm.fileInfo.data
			if (!datalist.length) {
				this.$message.warning('上传的设备数据为空')
				return false
			}
			this.validFailDataList = []
			const excelColumns = [...moduleBatchTaskThead]
			const excelDataList = JSON.parse(JSON.stringify(datalist))
			const deviceNoMap = new Map()
			const imeiMap = new Map()
			excelDataList.forEach((excelRowdata, index) => {
				excelRowdata['行数'] = index + 2
				const remark = []
				if (deviceNoMap.get(excelRowdata['设备通讯编号'])) remark.push(`设备通讯编号重复`)
				else deviceNoMap.set(excelRowdata['设备通讯编号'], 1)
				if (imeiMap.get(excelRowdata.IMEI)) remark.push(`IMEI重复`)
				else imeiMap.set(excelRowdata.IMEI, 1)
				excelColumns.forEach(item => {
					const { name, optional } = item
					const value = excelRowdata[name]
					if (optional == 1 && isBlank(value)) remark.push(`${name}不能为空`)
					if (remark.length) excelRowdata['异常说明'] = remark.join('；')
				})
				if (excelRowdata['异常说明']) this.validFailDataList.push(excelRowdata)
			})
			return !this.validFailDataList.length
		},

		/**
		 * 上传前模板生成
		 * @param {*} deviceViews
		 */
		async handleExcelImportTemalateExcel() {
			try {
				this.templateColumns = moduleBatchTaskThead
				const mustIdx = this.templateColumns.reduce((prev, cur, index) => {
					if (cur.optional === 1) {
						prev.push(index)
					}
					return prev
				}, [])
				const excelCase = this.templateColumns.map(m => m.case)
				const excelTHead = this.templateColumns.map(m => m.name)
				exportJsonToExcel(excelTHead, [excelCase], '模组任务数据模板', mustIdx)
				this.$message.success('模板下载成功')
			} catch (e) {
				console.log(e)
			}
		},

		handleDownloadFailData() {
			const excelDataList = []
			const excelTHead = ['行数', ...this.templateColumns.map(m => m.name), '异常说明']
			this.validFailDataList.forEach(m => {
				excelDataList.push(excelTHead.map(k => m[k]))
			})
			exportJsonToExcel(excelTHead, excelDataList, '模板异常数据')
		},

		handleRemoveExcelFile() {
			this.modelForm.fileInfo = null
			this.validFailDataList = []
		},
	},

	computed: {
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},
	},
}
</script>
<style lang="scss" scoped>
.form-block {
	.title {
		font-size: 17px;
		margin-bottom: 8px;
		color: #000;
		display: flex;
		justify-content: space-between;
		.download-template {
			color: #4d6bff;
			font-size: 12px;
			cursor: pointer;
		}
	}
	& + .form-block {
		margin-top: 18px;
	}
}
::v-deep .el-form-item {
	.el-upload {
		display: block;
		.el-upload-dragger {
			width: 100%;
			height: 142px;
			.el-icon-upload {
				font-size: 46px;
				margin: 30px 0 0;
			}
			.el-upload__text {
				font-size: 12px;
				line-height: 1;
			}
			.filename {
				margin-top: 52px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				padding: 0 12px;
			}
		}
	}
	.el-upload__tip {
		margin-top: 0;
	}
}
.file-name {
	color: #666;
	display: flex;
	align-items: center;
	font-size: 12px;
	margin-top: 16px;
	.iconfont {
		margin-left: 4px;
		cursor: pointer;
		color: #000;
		font-size: 14px;
	}
}

.hidden {
	visibility: hidden;
}

.content-error-tip {
	user-select: none;
	p {
		font-size: 12px;
		span {
			color: #ff0000;
		}

		em {
			color: #4d6bff;
			cursor: pointer;
		}
	}
}
</style>

<style lang="scss">
.gc-customer-cascader {
	.el-cascader-panel {
		.el-cascader-menu {
			&:nth-child(-n + 2) {
				display: none;
			}
			&:last-child {
				li {
					&:first-child {
						display: none;
					}
				}
			}
		}
	}
}
</style>
